import { TreeNavigator } from '@ispm/shared/bpmn-io/services/tree-navigator';
import Canvas from 'diagram-js/lib/core/Canvas';
import { Range, DimensionsCalculator } from '@ispm/shared/bpmn-io/services/dimensions-calculator';
import { ModelingUtil } from '@ispm/shared/bpmn-io/modeling-util';

export class TreeToScreenFitter {
  constructor(private treeNavigator: TreeNavigator,
              private canvas: Canvas,
              private elementRegistry,
              private dimensionsCalculator: DimensionsCalculator) {
  }

  public fit() {
    const currentNeighborhoodHeadNodeId = this.treeNavigator.getCurrentNeighborhoodHeadNodeId();
    if (currentNeighborhoodHeadNodeId == null) {
      this.canvas.zoom('fit-viewport', 'auto');
    } else {
      const shapesAtCurrentLevel =
        ModelingUtil.getDescendentNodesAtCurrentLayer(this.elementRegistry.get(currentNeighborhoodHeadNodeId));
      const fittingBoxOfNodes = this.dimensionsCalculator.computeFittingBoxOfNodes(shapesAtCurrentLevel);
      this.adjustView(fittingBoxOfNodes);
    }
  }

  private adjustView(fittingBoxOfNodes) {
    let centralizedY =
      this.dimensionsCalculator.centralizeOnAxis(new Range(fittingBoxOfNodes.minY, fittingBoxOfNodes.height), this.canvas.viewbox().outer.height);

    let newBox = {
      x: fittingBoxOfNodes.minX,
      y: centralizedY,
      width: fittingBoxOfNodes.width,
      height: fittingBoxOfNodes.height
    };

    this.canvas.viewbox(newBox);
  }
}
